// components/Header/index.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  HeaderContainer,
  HeaderWrapper,
  HeaderRight,
  UserInfo,
  ProfileContainer,
  ProfileImage,
  ProfilePic,
  ProfilePlaceholder,
  UserName,
  MyPageButton,
  LogoutButton,
} from './styles';

const Header = () => {
  const { user, logout ,isLoggedIn } = useAuth();
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const isOnMyPage = path.startsWith('/mypage');
  // 로그인 상태가 아니면 헤더를 렌더링하지 않음
  if (!isLoggedIn || !user) {
    return null;
  }
  // 차트 화면에선 GanttChart 자체 헤더(UserMenu 포함)와 중복되므로 숨김
  if (path === '/' || path.startsWith('/chart/')) {
    return null;
  }
  return (
    <HeaderContainer>
      <HeaderWrapper>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }} title="차트로 돌아가기">
          <ProfileContainer style={{ cursor: 'pointer' }}>
            <ProfileImage>
              {user?.profileImage ? (
                <ProfilePic
                  src={user?.profileImage}
                  alt="Profile"
                />
              ) : (
                <ProfilePlaceholder>
                  {user?.userId ? user?.userId.charAt(0).toUpperCase() : "U"}
                </ProfilePlaceholder>
              )}
            </ProfileImage>
            <UserName>{user?.userId || "User"}</UserName>
          </ProfileContainer>
        </Link>

        <HeaderRight>
          <UserInfo>
            {isOnMyPage ? (
              <MyPageButton to="/">차트로</MyPageButton>
            ) : (
              <MyPageButton to="/mypage">마이페이지</MyPageButton>
            )}
            <LogoutButton onClick={logout}>로그아웃</LogoutButton>
          </UserInfo>
        </HeaderRight>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;